// src/data/resources/articles/account-billing.ts

export const accountBillingArticles = [
    {
      id: "managing-subscription",
      categoryId: "account-billing",
      title: "Managing Your MailMaid Subscription",
      content: `
        <h2>Managing Your MailMaid Subscription</h2>
        <p>This guide helps you understand and manage your MailMaid subscription, including plan changes, billing information, and account settings.</p>
        
        <h3>Understanding Your Plan</h3>
        <p>MailMaid offers several subscription tiers:</p>
        <ul>
          <li><strong>Free</strong> - Basic features with limited email processing</li>
          <li><strong>Pro</strong> ($9.99/month) - Full access to all features for individuals</li>
          <li><strong>Enterprise</strong> ($19.99/user/month) - Team collaboration and advanced features</li>
        </ul>
        <p>To view your current plan:</p>
        <ol>
          <li>Log in to your MailMaid account</li>
          <li>Click on your profile picture in the top-right corner</li>
          <li>Select "Account & Billing"</li>
          <li>The "Current Plan" section shows your active subscription</li>
        </ol>
        
        <h3>Upgrading Your Plan</h3>
        <p>To upgrade from Free to Pro or from Pro to Enterprise:</p>
        <ol>
          <li>Go to "Account & Billing"</li>
          <li>Click "Upgrade Plan"</li>
          <li>Select your desired plan</li>
          <li>Choose billing frequency (monthly or annual)</li>
          <li>Enter payment information</li>
          <li>Review and confirm your purchase</li>
        </ol>
        <p>The upgrade takes effect immediately, giving you instant access to additional features.</p>
        
        <h3>Downgrading Your Plan</h3>
        <p>To downgrade your subscription:</p>
        <ol>
          <li>Go to "Account & Billing"</li>
          <li>Click "Change Plan"</li>
          <li>Select the plan you want to downgrade to</li>
          <li>Confirm the downgrade</li>
        </ol>
        <p>When downgrading:</p>
        <ul>
          <li>Your current plan remains active until the end of your billing period</li>
          <li>You'll be switched to the new plan at the next renewal date</li>
          <li>No refunds are provided for the unused portion of your current billing period</li>
          <li>You'll receive a confirmation email with the effective date of the change</li>
        </ul>
        
        <h3>Cancelling Your Subscription</h3>
        <p>To cancel your paid subscription:</p>
        <ol>
          <li>Go to "Account & Billing"</li>
          <li>Click "Cancel Subscription"</li>
          <li>Follow the prompts to complete the cancellation</li>
          <li>Provide feedback on your reason for cancelling (optional but appreciated)</li>
        </ol>
        <p>After cancellation:</p>
        <ul>
          <li>Your paid features remain available until the end of your current billing period</li>
          <li>Your account will automatically convert to the Free plan after that date</li>
          <li>You can reactivate your subscription at any time before the end date</li>
          <li>Your email data and settings will be preserved when converted to the Free plan</li>
        </ul>
        
        <h3>Managing Payment Methods</h3>
        <p>To update your payment information:</p>
        <ol>
          <li>Go to "Account & Billing"</li>
          <li>Select "Payment Methods"</li>
          <li>To add a new method: Click "Add Payment Method"</li>
          <li>To edit existing: Click "Edit" next to the payment method</li>
          <li>To delete: Click "Remove"</li>
          <li>To set default: Toggle "Make Default"</li>
        </ol>
        <p>MailMaid accepts major credit cards, PayPal, and in some regions, local payment methods.</p>
        
        <h3>Billing History & Invoices</h3>
        <p>To access your billing history and download invoices:</p>
        <ol>
          <li>Go to "Account & Billing"</li>
          <li>Select "Billing History"</li>
          <li>View a list of all transactions</li>
          <li>Click "Download" next to any invoice to save a PDF copy</li>
          <li>For receipt by email, toggle "Email Receipts" to ON</li>
        </ol>
        <p>Invoices contain all information required for expense reporting and tax purposes.</p>
        
        <h3>Changing Billing Frequency</h3>
        <p>To switch between monthly and annual billing:</p>
        <ol>
          <li>Go to "Account & Billing"</li>
          <li>Click "Change Billing Frequency"</li>
          <li>Select monthly or annual</li>
          <li>Review the price change</li>
          <li>Confirm the change</li>
        </ol>
        <p>Note that annual billing offers a 20% discount compared to monthly billing.</p>
        
        <h3>Enterprise Plan Administration</h3>
        <p>For Enterprise plan administrators:</p>
        <ul>
          <li>Manage team members through the "Team Management" section</li>
          <li>Add/remove users with the "Manage Users" button</li>
          <li>Assign admin privileges via user settings</li>
          <li>View team usage statistics in the "Team Analytics" dashboard</li>
          <li>Set up single sign-on through the "Security" tab</li>
        </ul>
        
        <h3>Contact Billing Support</h3>
        <p>If you have any questions or issues with your subscription:</p>
        <ul>
          <li>Email: billing@mailmaid.com</li>
          <li>Live chat: Available through the "Help" button during business hours</li>
          <li>Response time: Within 1 business day (typically much faster)</li>
        </ul>
        
        <p>We're committed to making your billing experience as smooth as possible. If you encounter any issues, our support team is ready to assist you.</p>
      `,
      excerpt: "Learn how to manage your MailMaid subscription, including upgrading, downgrading, and billing information.",
      order: 1
    }
  ];